module.exports = __webpack_public_path__ + "static/media/btn_backtotop87559e5993b70f869c379528b2d2ac9a.webp";